import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateEnrollmentForm from "../../forms/CreateOrUpdateEnrollmentForm";
import { EnrollmentResponseDto } from "../../shared/dtos/enrollment/EnrollmentResponseDto";

interface UpdateEnrollmentModalProps {
  open: boolean;
  onClose: () => void;
  enrollment: EnrollmentResponseDto | null;
  loading: boolean;
  error: string | null;
}

const UpdateEnrollmentModal: React.FC<UpdateEnrollmentModalProps> = ({
  open,
  onClose,
  enrollment,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Update Enrollment: ${enrollment?.studentName || ""}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateEnrollmentForm
      isEditing={true}
      enrollment={enrollment}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateEnrollmentModal;
